import { AfterViewInit, ElementRef, NgZone } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GoogleMapsService } from '../../services/google.maps.service';
var AddressInputComponent = /** @class */ (function () {
    function AddressInputComponent(googleMapService, zone, formBuilder) {
        this.googleMapService = googleMapService;
        this.zone = zone;
        this.formBuilder = formBuilder;
        this.isRequired = false;
        this.locationFormGroup = this.formBuilder.group({
            address: [null, [Validators.required]],
        });
    }
    Object.defineProperty(AddressInputComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (newValue) {
            this._value = newValue;
            this._notifyChange(this._value);
        },
        enumerable: true,
        configurable: true
    });
    AddressInputComponent.prototype.writeValue = function (obj) {
        this._value = obj;
        this.addressValue = !!this._value ? this._value.address : null;
    };
    AddressInputComponent.prototype.registerOnChange = function (fn) {
        this._notifyChange = fn;
    };
    AddressInputComponent.prototype.registerOnTouched = function (fn) { };
    AddressInputComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.googleMapService.getGoogle().then(function () {
            var autoComplete = new google.maps.places.Autocomplete(_this.inputElement.input.nativeElement);
            autoComplete.addListener('place_changed', function () {
                _this.zone.run(function () {
                    var place = autoComplete.getPlace();
                    if (place.geometry) {
                        console.log('address input', place);
                        var stateAbbr_1 = '', cityName_1 = '', country_1 = '';
                        if (place.address_components) {
                            place.address_components.forEach(function (x) {
                                if (x.types.any(function (y) { return y === 'administrative_area_level_1'; })) {
                                    stateAbbr_1 = x.short_name;
                                }
                                if (x.types.any(function (y) { return y === 'locality'; })) {
                                    cityName_1 = x.long_name;
                                }
                                if (x.types.any(function (y) { return y === 'country'; })) {
                                    country_1 = x.long_name;
                                }
                            });
                        }
                        _this.value = {
                            lat: place.geometry.location.lat(),
                            lng: place.geometry.location.lng(),
                            address: place.formatted_address,
                            address_components: place.address_components,
                            placeId: place.place_id,
                            cityName: cityName_1,
                            stateAbbr: stateAbbr_1,
                            country: country_1,
                        };
                    }
                    else {
                        _this.value = {
                            address: place.name,
                        };
                    }
                });
            });
        });
    };
    AddressInputComponent.prototype.clear = function () {
        this.addressValue = null;
        this.value = null;
    };
    return AddressInputComponent;
}());
export { AddressInputComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/address.input/address.input.component.ts.pre-build-optimizer.js